@if (endReached() && canShowConfirmation()) {
  <div class="mx-4 my-2 flex w-full flex-row justify-center">
    <ng-content></ng-content>
  </div>
}
<div class="aspect-video w-full">
  <video
    #videoElement
    playsinline
    webkit-playsinline
    class="video-js vjs-big-play-centered"
  ></video>
</div>
